// İzolasyon Mock Data
// İzolasyon malzemeleri, uygulama takibi ve m² hesabı

export const izolasyonlar = [
    {
        id: 'iz-001',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-10',
        tedarikci: 'BTM İzolasyon',
        tedarikciFirmaId: 'f-030',
        tip: 'su-izolasyon',
        marka: 'BTM Membran',
        model: '4mm Polimer Bitümlü',
        miktar: 500,
        birim: 'm²',
        birimFiyat: 180,
        toplamFiyat: 90000,
        durum: 'teslim',
        uygulamaDurumu: 'kismen',
        uygulamaYuzde: 60,
        uygulananMiktar: 300,
        kalanMiktar: 200,
        uygulamaYeri: 'A Blok Temel',
        insaatId: 'c-001',
        not: 'Temel su yalıtımı',
        createdAt: '2026-01-08T09:00:00Z',
        updatedAt: '2026-01-15T16:00:00Z',
    },
    {
        id: 'iz-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Onduline Türkiye',
        tedarikciFirmaId: 'f-031',
        tip: 'isi-izolasyon',
        marka: 'Izocam XPS',
        model: '5cm XPS Levha',
        miktar: 800,
        birim: 'm²',
        birimFiyat: 120,
        toplamFiyat: 96000,
        durum: 'teslim',
        uygulamaDurumu: 'bekliyor',
        uygulamaYuzde: 0,
        uygulananMiktar: 0,
        kalanMiktar: 800,
        uygulamaYeri: 'A Blok Dış Cephe',
        insaatId: 'c-001',
        not: 'Mantolama için depoda bekliyor',
        createdAt: '2026-01-10T10:00:00Z',
        updatedAt: '2026-01-12T14:00:00Z',
    },
    {
        id: 'iz-003',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-06',
        tedarikci: 'BTM İzolasyon',
        tedarikciFirmaId: 'f-030',
        tip: 'ses-izolasyon',
        marka: 'Rockwool',
        model: 'Taş Yünü 5cm',
        miktar: 300,
        birim: 'm²',
        birimFiyat: 95,
        toplamFiyat: 28500,
        durum: 'teslim',
        uygulamaDurumu: 'tamamlandi',
        uygulamaYuzde: 100,
        uygulananMiktar: 300,
        kalanMiktar: 0,
        uygulamaYeri: 'A Blok Ara Döşeme',
        insaatId: 'c-001',
        not: 'Ses yalıtımı tamamlandı',
        createdAt: '2026-01-05T08:00:00Z',
        updatedAt: '2026-01-14T17:00:00Z',
    },
    {
        id: 'iz-004',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Onduline Türkiye',
        tedarikciFirmaId: 'f-031',
        tip: 'cati-izolasyon',
        marka: 'Onduline',
        model: 'Çatı Membranı',
        miktar: 450,
        birim: 'm²',
        birimFiyat: 220,
        toplamFiyat: 99000,
        durum: 'bekliyor',
        uygulamaDurumu: 'bekliyor',
        uygulamaYuzde: 0,
        uygulananMiktar: 0,
        kalanMiktar: 450,
        uygulamaYeri: 'A Blok Çatı',
        insaatId: 'c-001',
        not: 'Çatı bitince uygulanacak',
        createdAt: '2026-01-15T11:00:00Z',
        updatedAt: '2026-01-15T11:00:00Z',
    },
    {
        id: 'iz-005',
        siparisTarihi: '2026-01-07',
        teslimTarihi: '2026-01-08',
        tedarikci: 'BTM İzolasyon',
        tedarikciFirmaId: 'f-030',
        tip: 'su-izolasyon',
        marka: 'BTM Membran',
        model: '3mm Polimer Bitümlü',
        miktar: 350,
        birim: 'm²',
        birimFiyat: 150,
        toplamFiyat: 52500,
        durum: 'teslim',
        uygulamaDurumu: 'tamamlandi',
        uygulamaYuzde: 100,
        uygulananMiktar: 350,
        kalanMiktar: 0,
        uygulamaYeri: 'B Blok Temel',
        insaatId: 'c-002',
        not: 'Temel yalıtımı tamamlandı',
        createdAt: '2026-01-07T09:00:00Z',
        updatedAt: '2026-01-12T15:00:00Z',
    },
];

// İzolasyon tipleri
export const izolasyonTipleri = [
    { key: 'su-izolasyon', label: 'Su İzolasyonu', icon: '💧' },
    { key: 'isi-izolasyon', label: 'Isı İzolasyonu', icon: '🌡️' },
    { key: 'ses-izolasyon', label: 'Ses İzolasyonu', icon: '🔇' },
    { key: 'cati-izolasyon', label: 'Çatı İzolasyonu', icon: '🏠' },
];

// Uygulama durumları
export const uygulamaDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'info' },
    { key: 'kismen', label: 'Kısmen Uygulandı', color: 'warning' },
    { key: 'tamamlandi', label: 'Tamamlandı', color: 'success' },
];

// İstatistikler
export const getIzolasyonStats = (insaatId) => {
    const filtered = insaatId
        ? izolasyonlar.filter(s => s.insaatId === insaatId)
        : izolasyonlar;

    const toplamMetrekare = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const uygulananMetrekare = filtered.reduce((acc, s) => acc + s.uygulananMiktar, 0);
    const kalanStok = filtered.filter(s => s.durum === 'teslim').reduce((acc, s) => acc + s.kalanMiktar, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const tamamlanan = filtered.filter(s => s.uygulamaDurumu === 'tamamlandi').length;

    return {
        toplamMetrekare,
        uygulananMetrekare,
        kalanStok,
        toplamMaliyet,
        siparisAdedi: filtered.length,
        tamamlanan,
        uygulamaOrani: toplamMetrekare > 0 ? Math.round((uygulananMetrekare / toplamMetrekare) * 100) : 0,
    };
};

// Helper: insaata göre filtrele
export const getIzolasyonByInsaat = (insaatId) => {
    if (!insaatId) return izolasyonlar;
    return izolasyonlar.filter(s => s.insaatId === insaatId);
};
